import threeArrowsComp from '../components/three-arrows-comp.vue'

export default {
  name: 'slide-project-texts',
  components:{
    threeArrowsComp
  },
  props: {
    isRootHover: {
      type: Boolean,
      default: false,
    },
    hoverModeByParent: {
      type: Boolean,
      default: true,
    }
  },
  data(){
    return {
      color: `white`,
      isThisHover:false,
    }
  },
  computed: {
    arrowsColor(){
      let byWhatCheck = this.hoverModeByParent ? this.isRootHover : this.isThisHover;

      switch(byWhatCheck) {
        case true:
          return 'white'
          break
        default:
          return 'orange'
      }
    }
  },
}



// WEBPACK FOOTER //
// ./src/includes/SlideProjectTexts.js